module.exports = __webpack_public_path__ + "static/media/fa-solid-900.237f4a0a.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-solid-900.woff2
// module id = 282
// module chunks = 36